var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { colors } from "../../theme";
export var VerticalLine = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-left: 2px solid ", ";\n"], ["\n  border-left: 2px solid ", ";\n"])), colors.mediumGrey);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map